import React from 'react'
import Hero from './hero'
import Aligners from './aligners'
import DentalImplants from './dentalImplants'
import CrownsBridges from './crownsbridges'
import Laminates from './laminates'
import Partialdenter from './Partialdenter'
import Aorthdontix from './aorthdontix'

// Rebuilt on the new design system (Task 8). The old services.css import is dropped - none
// of its rules are used by the rebuilt six section components below (see task-8-report.md
// for whether the file itself could be deleted under the scope gate).
const Index = () => {
  return (
    <>
      <Hero/>
      <Aligners/>
      <DentalImplants/>
      <CrownsBridges/>
      <Laminates/>
      <Partialdenter/>
      <Aorthdontix/>
    </>
  )
}

export default Index
